import { render, staticRenderFns } from "./AfterPayment.vue?vue&type=template&id=20547e3c&scoped=true&"
import script from "./AfterPayment.vue?vue&type=script&lang=js&"
export * from "./AfterPayment.vue?vue&type=script&lang=js&"
import style0 from "./AfterPayment.vue?vue&type=style&index=0&id=20547e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20547e3c",
  null
  
)

export default component.exports